<template>
  <div id="home-podcasts" class="fade-in-fast">
    <HomeFeaturedHeader title="SHOWS" :route="{ name: 'ShowsAll' }" />
    <LoadingItems v-if="!podcastsData.length" :height="300" />
    <HomePodcastsCarousel v-else :featured-data="podcastsData" />
  </div>
</template>
<script>
import axios from 'axios';
import HomeFeaturedHeader from '@/components/sections/HomeFeaturedHeader.vue';
import HomePodcastsCarousel from '@/components/sections/HomePodcastsCarousel.vue';
import LoadingItems from '@/components/ui/LoadingItems.vue';
export default {
  name: 'HomePodcasts',
  components: {
    HomeFeaturedHeader,
    HomePodcastsCarousel,
    LoadingItems
  },
  data: () => ({
    podcastsData: []
  }),
  mounted() {
    this.getFeaturedPodcasts();
  },
  methods: {
    getFeaturedPodcasts() {
      axios
        .get(this.$router.options.api + '/front/podcasts-module?type=PODCASTS')
        .then(response => (this.podcastsData = response.data))
        .catch(error => console.error(error));
    }
  }
};
</script>
